import React from 'react';

/**
 * Notifies the host app that the USER edited a field — the engine equivalent of
 * the `setIsFormTouched(true); setShowDownloadQuoteFooter(false);` side effect
 * formStepVulcan's `handleFormField` performs on every modification
 * (formStepVulcan.js:1238).
 *
 * Field edits in the engine path go through `engine.setValue`, which the app
 * never sees, so `isFormTouched` stayed false and "Save and Continue later"
 * (`disabled={!isFormTouched}`) never enabled. Bespoke sections already report
 * this — they receive `setIsFormTouched` directly — so plain leaf fields were the
 * only gap.
 *
 * The callback is invoked from the field registry's `withError` bridge, which
 * fires ONLY on genuine user interaction with a field component. That precision
 * is the point: `engine.dirty`/`engine.touched` would be unusable here because
 * PROGRAMMATIC writes (UserDetailsForm's populate effects, fieldRules
 * derivations) also route through `setValue` and would mark the form touched on
 * load.
 *
 * Lives in its own module to avoid an import cycle: `vulcanStructuralComponents`
 * already imports `VulcanFormField` from `fieldRegistry`, so the field registry
 * cannot import a context defined there.
 *
 * Defaults to null — with no provider (the legacy `?fce=0` dispatch path, or
 * tests) `withError` simply skips the notification.
 *
 * Receives `(fieldName, nextValue)`; returning `false` vetoes the write, which
 * is how legacy `handleFormField`'s early `return` guards (the access-points
 * max alert) are reproduced.
 *
 * @type {React.Context<null | ((fieldName?: string, nextValue?: any) => boolean | void)>}
 */
export const VulcanUserEditContext = React.createContext(null);

export default VulcanUserEditContext;
